import { useState } from "react";
import {
  provideComponent,
  connect,
  isInPlaceEditingActive,
  currentPage,
} from "scrivito";
import { jsonLd } from "./Schemas";
import { SchemaWidget, SchemaWidgetInstance } from "./SchemaWidgetClass";

const SchemaLd = connect(({ schema }: { schema: SchemaWidgetInstance }) => {
  const type = schema.get("type");
  const page = currentPage();

  if (!type) {
    return isInPlaceEditingActive() ? (
      <div className="alert alert-warning">No type selected</div>
    ) : null;
  }

  const json = jsonLd[type](schema, page);

  return <SchemaWidgetComponent type={type} json={json} />;
});

export const SchemaWidgetComponent = ({
  type,
  json,
}: {
  type: string;
  json: object;
}) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      {isInPlaceEditingActive() && (
        <div className="alert alert-warning">
          <strong>Json for {type}</strong>
          <div>
            <button
              className="btn bg-yellow px-3 py-1 mt-2 me-1"
              onClick={() => setOpen(!open)}
            >
              <i className={`las la-angle-${open ? "up" : "down"}`}></i>
            </button>
            <a
              href="https://developers.google.com/search/docs/appearance/structured-data"
              className="btn bg-yellow px-3 py-1 mt-2 me-1"
              target="_blank"
              rel="noopener noreferrer nofollow"
            >
              Validate your markup
            </a>
          </div>
          {open && <pre>{JSON.stringify(json, null, 2)}</pre>}
        </div>
      )}
      {json && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(json) }}
        />
      )}
    </>
  );
};

provideComponent(SchemaWidget, ({ widget }) => {
  return <SchemaLd schema={widget} />;
});
